import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import {
  defaultProPlanSelector,
  defaultProUnicornPlanSelector,
} from '@mm/state/selectors/subscriptionSelectors';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { PanelPlanTypes } from '../../../dashboard/pages/SettingsPage/BillingPanel/constants';
import { billingPlanDetails } from '../../../dashboard/pages/SettingsPage/BillingPanel/helpers';
import { PlanCard } from '../../../dashboard/pages/SettingsPage/BillingPanel/PlanCard/PlanCard';
import {
  ButtonColor,
  PrimaryButton,
} from '../../buttons/PrimaryButton/PrimaryButton';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import { OfferText } from '../OfferingFreeConsultationModal/OfferText/OfferText';
import './FreeTrialUpgradeModal.pcss';

export const FreeTrialUpgradeModal = ({
  passedPage,
}: {
  passedPage?: EnhancedBillingPage;
}) => {
  const defaultProPlan = useSelector(defaultProPlanSelector);
  const defaultUnicornPlan = useSelector(defaultProUnicornPlanSelector);
  const modalActions = useModalActions();
  const selectorPage = useSelector(activeFacebookPageSelector);
  const facebookPage = passedPage || selectorPage;

  const { november2021Pricing } = useSelector(combinedFeatureFlagsSelector);

  const [selectedPlan, setSelectedPlan] = useState<'pro' | 'unicorn'>(
    'unicorn',
  );

  const onContinue = () => {
    const plan = selectedPlan === 'pro' ? defaultProPlan : defaultUnicornPlan;

    if (facebookPage && selectedPlan && plan) {
      const congratsFirstLine = `At the end of your Free Trial, your ${
        selectedPlan === 'pro' ? 'Opeartor' : 'Startup'
      } plan will start and your card will be charged.`;
      const congratsText = (
        <div>
          <div>{congratsFirstLine}</div>
          {selectedPlan === 'pro' && (
            <div>Any Startup Features in use will be deactivated.</div>
          )}
        </div>
      );
      const onSuccessBilling = facebookPage?.hardLimitReached
        ? undefined
        : () =>
            modalActions.openGeneralTextModal({
              header: 'Congrats!',
              message: congratsText,
            });

      modalActions.openBillingModal({
        facebookPage,
        plan,
        subscription: facebookPage.subscription,
        onSuccessBilling,
      });
    }
  };

  return (
    <div>
      <ModalHeader className="free-trial-upgrade-modal__header">
        Choose your plan
      </ModalHeader>

      <ModalBody className="free-trial-upgrade-modal__body">
        <OfferText className="free-trial-upgrade-modal__offer-text" />
        <div className="free-trial-upgrade-modal__plan-cards">
          {['pro', 'unicorn'].map(planType => {
            let plan;
            if (planType === 'pro') {
              plan = defaultProPlan;
            } else if (planType === 'unicorn') {
              plan = defaultUnicornPlan;
            }
            return (
              <PlanCard
                key={planType}
                onClick={() => setSelectedPlan(planType as 'pro' | 'unicorn')}
                plan={billingPlanDetails(
                  planType as PanelPlanTypes,
                  plan,
                  false,
                  november2021Pricing,
                )}
                planDetailsOpen={true}
                isSelected={planType === selectedPlan}
              />
            );
          })}
        </div>
      </ModalBody>

      <ModalFooter className="free-trial-upgrade-modal__footer">
        <PrimaryButton
          disabled={!selectedPlan}
          onClick={onContinue}
          color={ButtonColor.green}
        >
          Continue
        </PrimaryButton>
      </ModalFooter>
    </div>
  );
};
